import { widgetManager } from '../src/widgetManager/index.js'
import balanceText from './utils/balance-text'
import templates from '/app/templates'

export default class Popover {
  constructor({ onClick, i18n, text1, text2, placement, iconSrc, widgetContainer, widgetIndex, icon }) {
    this.onClick = onClick
    this.icon = typeof icon === 'string' ? { type: 'filled', value: icon } : icon
    this.i18n = i18n
    this.iconSrc = iconSrc
    this.texts = { text1, text2 }
    this.widgetContainer = widgetContainer

    this.isActive = true

    this.styleNamespace = `cce-widget__popover`
    this.$element = document.createElement('div')
    this.$element.className = this.styleNamespace
    this.$element.classList.add(`${this.styleNamespace}-position-${placement}`)
    if (this.icon.type === 'text') {
      this.$element.classList.add('cce-widget__popover-bubbleTypeText')
    }

    this.widgetIndex = widgetIndex

    this.headsupAlwaysActive = widgetContainer.settings.widgets[this.widgetIndex].aiWhen
  }

  setActive(flag) {
    if (this.headsupAlwaysActive) {
      this.isActive = true
    } else {
      this.isActive = flag
    }
  }

  open() {
    try {
      let activeWidget = this.widgetContainer.settings.widgets[this.widgetIndex]
      if (activeWidget.aiWhat || activeWidget.mlWhat === 'ai_standard' || activeWidget.mlWhat === 'ai_custom') {
        let currentTexts = activeWidget.texts
        let headsupGreeting = currentTexts.find((x) => x.key === 'headsUpTitle' && x.type === 'general').value
        if (this.isOnlyEmoji(headsupGreeting)) {
          document.querySelector('.cce-widget__popover__container').classList.add('cce-widget__popover__container-emojiOnly')
        }
        this.$element.querySelector(`#${this.styleNamespace}__headsupText`).innerText = currentTexts.find((x) => x.key === 'headsUpText' && x.type === 'general').value
        this.$element.querySelector(`#${this.styleNamespace}__headsupGreeting`).innerText = headsupGreeting
      }
    } catch (e) {
      console.warn(e)
    }
  }

  render() {
    this.$element.innerHTML = templates.popover(this.getTemplateVariables())
    this.observeEvents()
  }

  isOnlyEmoji(text) {
    const emojiRegex = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g

    const matchedEmojis = text.match(emojiRegex) || []

    return matchedEmojis.length === 1 && matchedEmojis.join('') === text.trim()
  }

  getTemplateVariables() {
    const onlyEmoji = this.isOnlyEmoji(this.texts.text1)
    return {
      h: { balanceText },
      iconSrc: null,
      texts: {
        text1: this.texts.text1,
        text2: this.texts.text2,
      },
      onlyEmoji: onlyEmoji,
      iconTypeText: this.icon.type === 'text',
    }
  }

  observeEvents() {
    this.$element.addEventListener('click', () => {
      this.onClick()

      this.widgetContainer.triggerPublicEvent('action_headsup_click', {})
    })

    this.$element.querySelector(`.${this.styleNamespace}__close`).addEventListener('click', (e) => {
      widgetManager.closeHeadsup(true)
      this.setActive(false)
      e.stopPropagation()
    })
  }
}
